import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import TextField from '@mui/material/TextField';
import React from 'react';
import useWindowDimensions from '../../Reusables/VisualAndAccord/Hooks/useWindowDimensions';
import InputText from '../InputText/InputText';
import MyText from '../Texts/MyText';

function DobInput({
  maxDate,
  minDate,
  selectedDate,
  handleDateChange,
  dob,
  setDob,
}) {
  const { width } = useWindowDimensions();

  return (
    <div>
      {width <= 1024 ? (
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <div
            style={{
              width: '100%',
            }}
          >
            <MyText
              className="title"
              style={{
                marginBottom: '5px',
                fontSize: width > 576 ? '16px' : '12px',
              }}
            >
              Date of Birth
            </MyText>
            <DatePicker
              value={selectedDate}
              onChange={handleDateChange}
              format="dd/MM/yyyy"
              maxDate={maxDate}
              minDate={minDate}
              disableFuture
              renderInput={(params) => (
                <TextField
                  {...params}
                  fullWidth
                  margin="normal"
                  InputProps={{
                    ...params.InputProps,
                    disableUnderline: true,
                  }}
                />
              )}
            />
          </div>
        </LocalizationProvider>
      ) : (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <InputText
            type="date"
            containerStyle={{ width: '40%' }}
            titleStyle={{
              fontSize: width > 576 ? '16px' : '12px',
              marginBottom: '5px',
            }}
            textInputStyle={null}
            config={{
              value: dob,
              onChange: (e) => {
                setDob(e.target.value);
              },
              defaultValue: '1993-01-01',
              disabled: false,
              min: minDate,
              max: maxDate,
            }}
            title="Date of Birth"
            err={null}
            typed={null}
          />
        </div>
      )}
    </div>
  );
}

export default DobInput;
